export const formatNumber = (number: number) => {
  const formattedNumber = new Intl.NumberFormat().format(number);
  return formattedNumber;
};
export const graphFormatter = (number: number) => {
  if (number > 1000000) {
    return (number / 1000000).toFixed(1) + "M";
  } else if (number > 1000) {
    return (number / 1000).toFixed(1) + "K";
  } else {
    return number.toFixed(1);
  }
};
